import React from "react";
import styled from "styled-components";
import { ArrowUp } from "lucide-react";

const BackToTopBtn = styled.button`
  position: fixed;
  right: 85px;
  bottom: 150px;
  z-index: 9999;

  width: 52px;
  height: 52px;
  border-radius: 999px;

  border: 1px solid rgba(225, 173, 33, 0.45);
  background: rgba(10, 25, 47, 0.82);
  color: #e1ad21;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  box-shadow:
    0 14px 35px rgba(0, 0, 0, 0.45),
    0 0 0 6px rgba(225, 173, 33, 0.06); /* subtle glow ring */

  opacity: 0;
  pointer-events: none;
  transform: translateY(10px) scale(0.98);
  transition: opacity 0.25s ease, transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;

  &.show {
    opacity: 0.96;
    pointer-events: auto;
    transform: translateY(0) scale(1);
  }

  &:hover {
    opacity: 1;
    background: rgba(10, 25, 47, 0.94);
    transform: translateY(-2px) scale(1.02);
    box-shadow:
      0 18px 42px rgba(0, 0, 0, 0.5),
      0 0 0 8px rgba(225, 173, 33, 0.09);
  }

  &:active {
    transform: translateY(0) scale(0.99);
  }

  &:focus-visible {
    outline: 2px solid rgba(225, 173, 33, 0.75);
    outline-offset: 4px;
  }
`;


export default function BackToTop() {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const halfway = docHeight > 0 ? docHeight * 0.5 : 0;

      setShow(scrollTop > halfway);
    };

    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <BackToTopBtn
      className={show ? "show" : ""}
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
    >
      <ArrowUp size={18} />
    </BackToTopBtn>
  );
}
